<template>
  <div class="archive">
    <b-row class="mb-3 mt-4">
      <b-col cols="12">
        <h2 class="mr-4 h3">Arkiv</h2>
      </b-col>
    </b-row>

    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-0"
    ></b-pagination>

    <b-alert class="mt-3 mb-3" style="white-space: break-spaces;" :show="error !== null" variant="danger">
      {{error}}
    </b-alert>

    <b-table
      striped
      hover
      responsive="md"
      show-empty
      :items="items"
      :fields="fields"
      :busy="loading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #empty>
        <div class="m-4">
          <p class="h5"><em>Der er ikke nogen nyhedsbreve at vise</em></p>
        </div>
      </template>
      <template #emptyfiltered>
        <div class="m-4">
          <p class="h5"><em>Filtreringen gav ingen resultater</em></p>
        </div>
      </template>
      <template #table-busy>
        <div style="height: 600px;" class="d-flex justify-content-around align-items-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
      </template>
      <template v-slot:cell(sent_at)="row">
        <template v-if="row.item.sent_at">
          {{ row.item.sent_at | moment('dddd DD. MMMM, YYYY') }}
        </template>
        <em v-else>Ikke tilgængelig</em>
      </template>
      <template v-slot:cell(details)="row">
        <b-button size="sm" variant="primary" class="mr-2 float-right" @click="row.toggleDetails">
          Vis detaljer
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <h3 class="h6">Indhold</h3>
          <div v-html="row.item.body"></div>
          <hr>
          <h3 class="h6">Modtagere</h3>
          <template v-if="row.item.recipients.length">
            <span
              v-for="(recipient, index) of row.item.recipients"
              :key="index"
            >
              <template v-if="index > 0">,&nbsp;</template>{{recipient}}
            </span>
          </template>
          <template v-else><em>Ingen modtagere</em></template>
        </b-card>
      </template>
    </b-table>

    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-0"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    error: null,
    rows: 10,
    perPage: 25,
    currentPage: 1,
    sortBy: 'full_name',
    sortDesc: false,
    selectedUser: null,
    filter: '',
    timeout: null,
    items: [],
    fields: [
      {
        key: 'id',
        label: 'ID'
      },
      {
        key: 'subject',
        label: 'Emne',
        sortable: false
      },
      {
        key: 'sent_at',
        label: 'Dato sendt',
        sortable: false
      },
      {
        key: 'details',
        label: '',
        sortable: false
      }
    ]
  }),
  mounted() {
    this.getNewsletters()
  },
  watch: {
    queryString: function () {
      clearTimeout(this.timeout)
      let that = this
      this.timeout = setTimeout(function () {
        that.getNewsletters()
      }, 500)
    }
  },
  computed: {
    queryString() {
      return '?page=' + this.currentPage + '&query=' + this.filter + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc
    }
  },
  methods: {
    getNewsletters() {
      this.loading = true
      let config = this.$store.getters.getConfig
      this.axios.get('/api/newsletters/' + this.queryString, config).then((response) => {
        this.items = response.data.results
        this.rows = response.data.count
        this.loading = false
      }).catch(error => {
        this.error = 'Listen af sendte nyhedsbreve kunne ikke hentes.\n\n' + error + '\n\nPrøv igen senere.'
        this.loading = false
      })
    },
  }
}
</script>

<style>

</style>